export const iconFontAwesomeUsersPeoplePeopleRoof = (
	<i className="fa-solid fa-people-roof"></i>
);
